export default "__VITE_ASSET__COgbPmTA__"